<template>
  <div>
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>
    <b-row>
      <b-col sm="6" lg="6">
        <b-card no-body class="pushsAtivos">
          <b-card-body class="pb-0">
            <b-button
              class="float-right"
              variant="transparent p-0"
              right
              no-caret
              id="pushs-mensais"
            >
              <i class="fa fa-info-circle fa-lg tamanhoIcon"></i>
            </b-button>
            <b-popover target="pushs-mensais" triggers="hover focus">
              <template slot="title">Informação</template>
              Este número é um
              <strong>totalizador</strong>
              para os pacotes
              <strong>mensais</strong>
              que estão ativos
              <span class="text-danger">no momento</span>.
            </b-popover>
            <h4 class="mb-0">{{ pacoteMensal }}</h4>
            <p>Pushs mensais ativos</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="6" lg="6">
        <b-card no-body class="pushsAtivosAdicionais">
          <b-card-body class="pb-0">
            <b-button
              class="float-right"
              variant="transparent p-0"
              right
              no-caret
              id="pushs-adicionais"
            >
              <i class="fa fa-info-circle fa-lg tamanhoIcon"></i>
            </b-button>
            <b-popover target="pushs-adicionais" triggers="hover focus">
              <template slot="title">Informação</template>
              Este número é um
              <strong>totalizador</strong>
              para os pacotes
              <strong>adicionais</strong> que estão ativos
              <span class="text-danger">no momento</span>.
            </b-popover>
            <h4 class="mb-0">{{ pacoteAdicional }}</h4>
            <p>Pushs adicionais ativos</p>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6" lg="3">
        <b-card no-body class="pushsEnviados">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{ qtdpushsenviados }}</h4>
            <p>Pushs enviados</p>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="pushsRecebidos">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{ qtdpushsrecebidos }}</h4>
            <p>Pushs recebidos</p>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="pushsVisualizados">
          <b-card-body class="pb-0">
            <b-button
              class="float-right"
              variant="transparent p-0"
              right
              no-caret
              id="pushs-visualizados"
            >
              <i class="fa fa-info-circle fa-lg"></i>
            </b-button>
            <b-popover target="pushs-visualizados" triggers="hover focus">
              <template slot="title">Informação</template>
              A função de pushs visualizados está em versão
              <strong>beta</strong> e poderá apresentar instabilidades.
            </b-popover>
            <h4 class="mb-0">{{ qtdpushsvisualizados }}</h4>
            <p>Pushs visualizados</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="6" lg="3">
        <b-card no-body class="pushsRejeitados">
          <b-card-body class="pb-0">
            <b-button
              class="float-right"
              variant="transparent p-0"
              right
              no-caret
              id="pushs-rejeitados"
            >
              <i class="fa fa-info-circle fa-lg"></i>
            </b-button>
            <b-popover target="pushs-rejeitados" triggers="hover focus">
              <template slot="title">Informação</template>
              A função de pushs visualizados está em versão
              <strong>beta</strong> e poderá apresentar instabilidades.
            </b-popover>
            <h4 class="mb-0">{{ qtdpushsrejeitados }}</h4>
            <p>Pushs rejeitados</p>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col xl="6" lg="6" md="6" sm="12">
              <nav>
                <b-pagination
                  :total-rows="getRowCount(items)"
                  :per-page="perPage"
                  v-model="currentPage"
                  prev-text="Anterior"
                  next-text="Próxima"
                />
              </nav>
            </b-col>
            <b-col xl="6" lg="6" md="6" sm="12">
              <b-button
                variant="success"
                class="botaoCadastrarCupom"
                @click="redirect"
                >Cadastrar campanha</b-button
              >
            </b-col>
          </b-row>
          <b-table
            v-if="items.length > 0"
            :items="items"
            :fields="fields"
            bordered
            striped
            hover
            :current-page="currentPage"
            :per-page="perPage"
          ></b-table>
          <div v-else>
            <center class="mt-3">
              <i class="fa fa-frown-o fa-custom-size"></i>
              <h4>Desculpe, não encontramos nenhuma promoção :(</h4>
              <h5>
                Para iniciar, clique no botão acima e comece as integrações!
              </h5>
            </center>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";

export default {
  name: "promocoes",
  components: {
    Loading,
  },
  data: function () {
    return {
      isLoading: false,
      temPromocoes: false,
      numCampanhas: 0,
      titulo: "",
      descricao: "",
      items: [],
      fields: [
        { key: "titulo", label: "Título" },
        { key: "descricao", label: "Descrição" },
        { key: "datahoracadastro", label: "Cadastro" },
        { key: "datahoradisparopush", label: "Envio" },
        { key: "qtdpushsenviados", label: "Enviados" },
        { key: "qtdpushsrecebidos", label: "Recebidos" },
        { key: "qtdpushsvisualizados", label: "Visualizados" },
      ],
      haveItems: false,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      qtdpushsrecebidos: 0,
      qtdpushsvisualizados: 0,
      qtdpushsrejeitados: 0,
      qtdpushsenviados: 0,
      pacoteMensal: 0,
      pacoteAdicional: 0,
      modalShow: false,
    };
  },
  methods: {
    getRowCount(items) {
      return items.length;
    },

    redirect() {
      localStorage.setItem("tipoid", 5);
      this.$router.push({ path: `/cadastrar-campanha` });
    },

    async retornaTotalizadores() {
      const url = `${
        config.default.servidor
      }/gerencial/retorna-totalizadores-push/${localStorage.getItem(
        "enterprise_id"
      )}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: `${config.default.authorizationBasic}` },
        });

        if (response.status == 200) {
          this.qtdpushsrecebidos = response.data.data.qtdpushsrecebidos;
          this.qtdpushsvisualizados = response.data.data.qtdpushsvisualizados;
          this.qtdpushsrejeitados = response.data.data.qtdpushsrejeitados;
          this.qtdpushsenviados = response.data.data.qtdpushsenviados;
          this.pacoteMensal = response.data.data.pacotes.mensal;
          this.pacoteAdicional = response.data.data.pacotes.avulso;
        }
      } catch (error) {
        console.log({ error });
      }
    },

    async retornaCampanhas() {
      const url = `${
        config.default.servidor
      }/gerencial/retorna-campanhas/${localStorage.getItem("enterprise_id")}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: `${config.default.authorizationBasic}` },
        });

        if (response.status == 200) {
          this.items = response.data.data;
        }
      } catch (error) {
        console.log({ error });
      }
    },
  },

  async beforeMount() {
    this.isLoading = true;
    await this.retornaTotalizadores();
    await this.retornaCampanhas();
    this.isLoading = false;
  },
};
</script>

<style scoped>
.pushsAtivos{
  font-weight: 400;
  color: white;
  background-color: #10400D
  /* background-color: #299267; */ 
}

.pushsAtivosAdicionais{
  font-weight: 400;
  color: white;
  background-color: #255022;
  /* background-color: #1CB274; */
}

.pushsEnviados{
  font-weight: 400;
  color: white;
  background-color: #228582;
}


.pushsRecebidos{
  font-weight: 400;
  color: white;
  background-color: #177BDA;
}

.pushsVisualizados{
  font-weight: 400;
  color: white;
  background-color: #06AC5B;
}

.pushsRejeitados{
  font-weight: 400;
  color: white;
  background-color: #D44545;
}
</style>

